const { zipCodeRegexNumeric, onlyNumericNormalize } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Sudan',
  code: 'SD',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Town' },
    zipCode: { label: 'Postcode', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [['company'], ['address'], ['address2'], ['zipCode'], ['city']],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode'], ['city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers like 11111'
    }
  ]
};
